//
import { RFormFields } from '@/components/reusable_components/next'
import ProviderModel from '@/models/Purchase/PchProvider'

//
export default RFormFields
  .from([
    // {
    //   name: 'pch_purchase_invoice_id',
    //   type: 'text-field',
    //   props: {
    //     label: 'Id de la factura',
    //   },
    // },
    {
      name: 'rut',
      type: 'rut-field',
      props: {
        label: 'Rut',
      },
    },
    {
      name: 'business_name',
      type: 'text-field',
      props: {
        label: 'Nombre',
      },
    },
  ])
